import { FalhaServico } from '../falha-servico';

export class InformacaoPositivo{
  operacoes: Array<any>;

  constructor(){
      this.operacoes = [];
  }

}


export class Operacao{
    falhaServico = new FalhaServico();
    tipoOperacao: string;
    tipoModalidade: string;
    modalidade: string;
    empresa: string;
    cnpj: string;
    numeroContrato: string;
    numeroOperacao: string;
    agencia : string;
    inicioContrato: string;
    ultimaAtualizacao: string;
}


export class Detalhe{
    dataVencimento: string;
    valorParcela: string;
    dataPagamento: string;
    valorPagamento: string;
}

export class DetalheParcelaRotativo{
    dataVencimento: string;
    saldoUtilizado: string;
}



export class Consorcio extends Operacao{
    terminoPrevisto : string;
    cota : string;
    situacaoCota : string;
    sequencia : string;
    temValorContratado : string;
    totalParcelas : string;
    saldoDevedorTotal : string;
    detalhe12Meses : Array<Detalhe>;
    constructor(){
        super();
        this.detalhe12Meses = [];
    }
}

export class CartaoCredito extends Operacao{
    ultimosNumerosCartao : string;
    valorUltimaFatura : string;
    saldoProxFatura : string;
    detalhe12Meses : Array<Detalhe>;
    constructor(){
        super();
        this.detalhe12Meses = [];
    }
}

export class Parcelado extends Operacao{
    terminoPrevisto : string;
    valorTotalContrato : string;
    totalParcelas : string;
    parcelasAVencer : string;
    valorProximaParcela : string;
    detalhe12Meses : Array<Detalhe>;
    constructor(){
        super();
        this.detalhe12Meses = [];
    }
}

export class Rotativo extends Operacao{
    detalhe12Meses : Array<DetalheParcelaRotativo>;
    constructor(){
        super();
        this.detalhe12Meses = [];
    }
}

export class Consumo extends Operacao{
    total: string;
    valorUltimaParcela : string;
    detalhe12Meses : Array<Detalhe>;
    constructor(){
        super();
        this.detalhe12Meses = [];
    }
}


